
import Vue from 'vue';
import QTray from '../../Tray/NewTray.vue';
import GeneralDatePicker from './DatePicker.vue';
/**
- Value is only for label inside Input component, while the real date value taken from <b>@setDate</b>
- If want to change input text color, modify <b> .eu-datepicker-container .vdp-datepicker input </b>
- You can use flat variant with props <b>flatFormat</b> mening it won't slide down when date selected (standby mode)
**/
export default Vue.extend<any, any, any, any>({
  name: 'SliderDatePicker',
  components: {
    QTray,
    GeneralDatePicker
  },
  data() {
    return {
      modal: false,
      selectedSort: '',
      dob: null,
      updatedDate: null,
      givendate: ''
    };
  },
  props: {
    /**
     * Set value on datepicker
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Set id on datepicker
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set placeholder
     */
    label: {
      type: String,
      default: 'Select date'
    },
    /**
     * Set button text
     */
    primaryButtonText: {
      type: String,
      default: 'Select'
    },
    /**
     * Set primary button color
     */
    primaryButtonType: {
      type: String,
      default: 'primary'
    },
    /**
     * Set default date
     */
    defaultDate: {
      type: String
    },
    /**
     * Set maximum year on date picker
     */
    maxYear: {
      type: Number,
      default: () => new Date().getFullYear()
    },
    /**
     * Set range year on date picker
     */
    rangeYear: {
      type: Number,
      default: 61
    },
    /*
     * Set on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /*
     * Set on success state
     */
    success: {
      type: Boolean,
      default: false
    },
    /*
     * set SliderDatePicker on open state
     */
    open: {
      type: Boolean,
      default: false
    },
    /*
     * set SliderDatePicker on flat state
     */
    flatFormat: {
      type: Boolean,
      default: false
    },
    /**
     * Set Minimum Year of the SliderDatePicker
     */
    minYear: {
      type: Number
    },
    /**
     * Hide date section
     */
    hideDate: {
      type: Boolean,
      default: false
    },
    /**
     * Hide month section
     */
    hideMonth: {
      type: Boolean,
      default: false
    },
    /**
     * Hide year section
     */
    hideYear: {
      type: Boolean,
      default: false
    },
    /**
     * Date Formatter
     */
    dateFormatter: {
      type: Function,
      default: (date: string) => date
    },
    /**
     * List of Month language.
     */
    monthList: {
      type: Array,
      default: () => [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    }
  },
  watch: {
    defaultDate(defaultDate) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const date = currentDate.getDate();
      if (defaultDate) {
        this.givendate = defaultDate;
      } else {
        this.givendate = `${year}-${`0${month}`.slice(-2)}-${`0${date}`.slice(-2)}`;
      }
      this.dob = defaultDate;
    }
  },
  created() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const date = currentDate.getDate();
    if (this.defaultDate) {
      this.givendate = this.defaultDate;
    } else {
      this.givendate = `${year}-${`0${month}`.slice(-2)}-${`0${date}`.slice(-2)}`;
    }
    this.dob = this.defaultDate ? this.givendate : null;
    this.modal = this.open || this.flatFormat;
  },
  computed: {
    containerClasses() {
      return {
        error: this.error,
        success: this.success,
        disabled: this.$attrs.disabled === true
      };
    },
    dateObject() {
      return new Date(this.dob);
    }
  },
  methods: {
    setDate(params: 'primary' | 'secondary' | undefined) {
      if (params === 'primary') {
        this.dob = this.updatedDate;
        /**
         * Set date
         *  @event setDate
         * @type {function}
         */
        this.$emit('setDate', this.dob);
      }
      this.givendate = this.dob;
    },
    updateDate(result: any) {
      this.givendate = null;
      this.updatedDate = result;
    },
    handleClick(e: any) {
      if (!this.$attrs.disabled) {
        this.modal = !this.modal;
      }
      /**
       * When user click date picker
       *  @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
